import { render, staticRenderFns } from "./VaimoButtons.vue?vue&type=template&id=445da249&scoped=true&"
import script from "./VaimoButtons.vue?vue&type=script&lang=ts&"
export * from "./VaimoButtons.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoButtons.vue?vue&type=style&index=0&id=445da249&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445da249",
  null
  
)

export default component.exports